import { Users, Infinity as InfinityIcon, Fingerprint, HeartHandshake, Compass, Sparkles } from "lucide-react";
import { FadeUp, SectionTag } from "./Reveal";

const CARDS = [
    {
        icon: Users,
        title: "Social is the endgame",
        body: "Conversation, collaboration, and connection are the core loop — not a side activity between fights.",
        span: "md:col-span-2 lg:col-span-7",
    },
    {
        icon: InfinityIcon,
        title: "Persistent by default",
        body: "The world keeps living when you log off. What you build and who you know still matter tomorrow.",
        span: "lg:col-span-5",
    },
    {
        icon: Fingerprint,
        title: "Identity over items",
        body: "Progress is who you become — your style, your reputation, your place in the city.",
        span: "lg:col-span-4",
    },
    {
        icon: HeartHandshake,
        title: "Community as content",
        body: "Clubs, crews, neighborhoods, and events made by players give the city its culture.",
        span: "lg:col-span-4",
    },
    {
        icon: Compass,
        title: "Freedom to wander",
        body: "No quest markers dragging you forward. Explore, drift, and find your own reasons to stay.",
        span: "lg:col-span-4",
    },
    {
        icon: Sparkles,
        title: "Player-driven, always",
        body: "Meaningful experiences authored by the people inside the world — we build the stage, you write the stories.",
        span: "md:col-span-2 lg:col-span-12",
    },
];

export const Different = () => (
    <section id="different" className="relative py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionTag index="03" label="What Makes Us Different" />

            <FadeUp>
                <h2
                    data-testid="different-heading"
                    className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl text-white leading-tight max-w-2xl"
                >
                    Most MMOs ask what you can kill.{" "}
                    <span className="font-serif-accent italic font-medium text-[#C084FC]">
                        We ask who you can become.
                    </span>
                </h2>
            </FadeUp>

            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5">
                {CARDS.map((c, i) => (
                    <FadeUp key={c.title} delay={(i % 3) * 0.1} className={c.span}>
                        <article
                            data-testid={`different-card-${i + 1}`}
                            className="group relative h-full bg-[#12121A] border border-white/[0.08] p-8 sm:p-10 overflow-hidden hover:border-[#A855F7]/40 transition-colors duration-500"
                        >
                            <div className="absolute -top-16 -right-16 w-48 h-48 bg-[#A855F7]/0 group-hover:bg-[#A855F7]/10 blur-3xl rounded-full transition-colors duration-700 pointer-events-none" />
                            <c.icon className="w-6 h-6 text-[#A855F7]" />
                            <h3 className="mt-6 font-display font-bold text-xl sm:text-2xl text-white">
                                {c.title}
                            </h3>
                            <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed max-w-lg">
                                {c.body}
                            </p>
                            <span className="absolute top-6 right-8 font-mono-meta text-[10px] tracking-[0.3em] text-slate-600">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                        </article>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);
